import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Login from "./login";
import Register from "./register";
import BrandLogo from "../Common/BrandLogo";
import "./AuthLanding.css";

const FEATURE_CARDS = [
  {
    icon: "shield",
    text: "Privately built. Not government-run.",
  },
  {
    icon: "lock",
    text: "Your personal data is not sold.",
  },
  {
    icon: "star",
    text: "Local visibility is not pay-to-boost.",
  },
  {
    icon: "sprout",
    text: "Post goods, plants, jobs, events, and Land Share.",
  },
  {
    icon: "message",
    text: "Message, bid, apply, request, and connect.",
  },
  {
    icon: "pin",
    text: "Maps and local search help people find you.",
  },
  {
    icon: "folder",
    text: "Private Farm Records stay private.",
    wide: true,
  },
  {
    icon: "tractor",
    text: "Built for real farm life, not city-click confusion.",
    wide: true,
  },
];

const AuthFeatureIcon = ({ type }) => {
  const commonProps = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
  };

  switch (type) {
    case "shield":
      return (
        <svg {...commonProps}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M12 8v8" />
        </svg>
      );
    case "lock":
      return (
        <svg {...commonProps}>
          <rect x="5" y="11" width="14" height="10" rx="2" />
          <path d="M8 11V8a4 4 0 0 1 8 0v3" />
          <path d="M12 15v2" />
        </svg>
      );
    case "star":
      return (
        <svg {...commonProps}>
          <path d="m12 2 3 6 6.5.9-4.7 4.6 1.1 6.5L12 17l-5.9 3 1.1-6.5L2.5 8.9 9 8l3-6z" />
        </svg>
      );
    case "sprout":
      return (
        <svg {...commonProps}>
          <path d="M12 21V10" />
          <path d="M12 10C9 5 5 5 3 7c2 4 6 5 9 3z" />
          <path d="M12 13c3-5 7-5 9-3-2 4-6 5-9 3z" />
        </svg>
      );
    case "message":
      return (
        <svg {...commonProps}>
          <path d="M4 5h16v11H8l-4 4V5z" />
          <path d="M8 10h8" />
          <path d="M8 13h5" />
        </svg>
      );
    case "pin":
      return (
        <svg {...commonProps}>
          <path d="M12 21s7-5.3 7-12a7 7 0 0 0-14 0c0 6.7 7 12 7 12z" />
          <circle cx="12" cy="9" r="2.5" />
        </svg>
      );
    case "folder":
      return (
        <svg {...commonProps}>
          <path d="M3 6h7l2 2h9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6z" />
        </svg>
      );
    case "tractor":
      return (
        <svg {...commonProps}>
          <path d="M3 17h3" />
          <path d="M10 17h5" />
          <path d="M17 17h4" />
          <circle cx="7" cy="17" r="3" />
          <circle cx="18" cy="17" r="2" />
          <path d="M10 17V8H6" />
          <path d="M10 10h5l3 5" />
          <path d="M6 8V5h4" />
        </svg>
      );
    default:
      return null;
  }
};

const AuthLanding = ({ setUser }) => {
  const location = useLocation();
  const [mode, setMode] = useState(
    location.pathname === "/register" ? "register" : "login"
  );

  useEffect(() => {
    setMode(location.pathname === "/register" ? "register" : "login");
  }, [location.pathname]);

  return (
    <div className="auth-page auth-landing-page">
      <section className="auth-landing-shell">
        <div className="auth-left-panel">
          <div className="auth-brand-pill">
            <BrandLogo />
          </div>

          <h1>Local fields. Farm goods. Real connections.</h1>

          <p>
            A local farming platform for farm goods, jobs, plants, land access,
            events, community connections, maps, messages, and private farm
            records.
          </p>

          <div className="auth-feature-list">
            {FEATURE_CARDS.map((card) => (
              <div
                className={`auth-feature-card${card.wide ? " auth-feature-card-wide" : ""}`}
                key={card.text}
              >
                <span className="auth-feature-icon">
                  <AuthFeatureIcon type={card.icon} />
                </span>
                <span className="auth-feature-text">{card.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="auth-right-panel">
          <div className="auth-card">
            <div className="auth-tabs"></div>

            {mode === "login" ? (
              <Login
                setUser={setUser}
                embedded
                switchToRegister={() => setMode("register")}
              />
            ) : (
              <Register embedded switchToLogin={() => setMode("login")} />
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AuthLanding;
